if (!customElements.get('md-card-options')) {
  customElements.define('md-card-options', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.ready) return;
        this.card = this.closest('.product-card');
        this.form = this.closest('form');
        this.select = this.querySelector('select');
        this.button = this.form?.querySelector('[type="submit"]');
        this.input = this.form?.querySelector('input[name="id"]');
        if (!this.card || !this.select || !this.button || !this.input) return;
        this.price = this.card.querySelector(`[id="${this.dataset.priceId}"]`);
        this.initialPrice = this.price?.innerHTML;
        this.ready = true;
        this.change = () => this.update(true);
        this.guard = event => {
          if (this.input.disabled || !this.input.value) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.form.closest('product-form')?.handleErrorMessage?.(this.dataset.prompt);
            this.select.focus();
          }
        };
        this.select.addEventListener('change', this.change);
        this.form.addEventListener('submit', this.guard, true);
        if (!this.select.value) {
          const firstAvailable = this.querySelector('template[data-available="true"]');
          if (firstAvailable) this.select.value = firstAvailable.dataset.variantId;
        }
        this.update();
      });
    }
    disconnectedCallback() {
      this.select?.removeEventListener('change', this.change);
      this.form?.removeEventListener('submit', this.guard, true);
      this.ready = false;
    }
    update(updateImage = false) {
      const choice = Array.from(this.querySelectorAll('template[data-variant-id]')).find(node => node.dataset.variantId === this.select.value);
      const available = choice?.dataset.available === 'true';
      this.input.value = available ? choice.dataset.variantId : '';
      this.input.disabled = !available;
      this.button.disabled = !available;
      this.button.setAttribute('aria-disabled', String(!available));
      this.form.closest('product-form')?.handleErrorMessage?.();
      if (this.price) {
        this.price.setAttribute('aria-live', 'polite');
        this.price.innerHTML = choice ? choice.innerHTML : this.initialPrice;
      }
      if (!choice) return;
      const image = this.card.querySelector('.product-card__image__url img');
      if (updateImage && image && choice.dataset.image) {
        image.removeAttribute('srcset');
        image.src = choice.dataset.image;
        image.alt = choice.dataset.alt || '';
      }
      this.card.querySelectorAll('.md-card-badge--sale').forEach(badge => { badge.hidden = choice.dataset.sale !== 'true'; });
      this.card.querySelectorAll('.product-card__image__url, .product-card__heading a').forEach(link => {
        const url = new URL(link.href, window.location.href);
        url.searchParams.set('variant', choice.dataset.variantId);
        link.href = url.href;
      });
    }
  });
}
